/* eslint-disable */
// 定义全局变量【可以配置多个后端】

// // // 本地开发
// const frontRootUrl = 'http://192.168.0.14:8080'

// 内网
// const frontRootUrl = 'http://192.168.0.150:12235'

// // 线上
// const frontRootUrl = 'ttps://cxai.cxstar.cn'
// const rootUrl = 'https://cxai.cxstar.cn/back'
// const rootUrl_slow = 'https://cxai.cxstar.cn/back_latency'

let frontRootUrl = "";
let rootUrl = "";
let rootUrl_slow = "";
let childrenUrl = "";
// 获取当前页面的IP/域名
const currentHost = window.location.hostname;
const isLocalDevHost = ["192.168.0.39", "192.168.0.146", "localhost", "127.0.0.1"].includes(currentHost);

// 1. 判断本地开发环境（匹配本地IP）
if (isLocalDevHost) {
  frontRootUrl = "http://192.168.0.39:8080";
  rootUrl = "/back"; // 本地开发由主框架 devServer 代理到测试后端
  rootUrl_slow = "/back_latency"; // 本地开发由主框架 devServer 代理到测试后端
  childrenUrl = "https://cxaitest.cxstar.cn";
  // rootUrl = "https://cxai.cxstar.cn/back"; // 接口访问线上地址
}
// 2. 判断内网环境（匹配内网IP）
else if (currentHost === "192.168.0.150" || currentHost === "cxai.cxstar.cn") {
  //   // 内网
  //   frontRootUrl = 'http://192.168.0.150:12235';
  // 公网
  frontRootUrl = "https://cxai.cxstar.cn";
  rootUrl = "https://cxai.cxstar.cn/back";
  rootUrl_slow = "https://cxai.cxstar.cn/back_latency";
  childrenUrl = "https://jyx.cxstar.cn";
} else if (currentHost === "jyx.cxstar.cn") {
  //   // 内网
  // 公网
  frontRootUrl = "https://jyx.cxstar.cn";
  rootUrl = "https://jyx.cxstar.cn/back";
  rootUrl_slow = "https://jyx.cxstar.cn/back_latency";
  childrenUrl = "https://jyx.cxstar.cn";
} else if (currentHost === "cxaitest.cxstar.cn") {
  // 公网
  frontRootUrl = "https://cxaitest.cxstar.cn";
  rootUrl = "https://cxaitest.cxstar.cn/back";
  rootUrl_slow = "https://cxaitest.cxstar.cn/back_latency";
  childrenUrl = "https://cxaitest.cxstar.cn";
}
// // 3. 线上环境（默认，匹配线上域名）
// else if (currentHost === 'cxai.cxstar.cn') {
//   frontRootUrl = 'https://cxai.cxstar.cn';
//   rootUrl_slow = 'https://cxai.cxstar.cn/back_latency';
// }

const globalUrl = {
  rootUrl: rootUrl,

  file_upload: rootUrl + "/upload/file_upload/",
  // upload_recent: rootUrl + '/cxai/upload/upload_recent',

  long_question_cache: rootUrl + "/academic_search/long_question_cache",
  stream_chat: rootUrl + "/academic_search/stream",
  rag_stream_chat: rootUrl + "/rag/stream",
  search_log_record: "https://jyx.cxstar.cn/api/v1/log-search/recordLog",
  // 流式一次性 ticket 端点。固定挂在 rag 路由下，两条流式通道共用
  stream_ticket: rootUrl + "/rag/stream-ticket",
  research_personalization_options: rootUrl + "/research/personalization-options",
  extend_q: rootUrl + "/academic_search/extend_q",
  tool_list: rootUrl + "/tool_list",
  academic_search___random_q: rootUrl + "/academic_search/random_q",
  word_segment_search___random_q: rootUrl + "/word_segment_search/random_q",

  cxai_conversation_add: rootUrl + "/conversation/add",
  cxai_conversation_select_all: rootUrl + "/conversation/select_all",
  cxai_conversation_select_one: rootUrl + "/conversation/select_one",

  jyx_word_segment_search: rootUrl + "/word_segment_search",

  full_txt_art_analysis: rootUrl_slow + "/art_analysis_slow/full_txt",
  full_txt_art_analysis_case: rootUrl + "/art_analysis/full_txt_case",
  full_txt_art_analysis_recent: rootUrl + "/art_analysis/full_txt_recent",
  topic_assistance: rootUrl_slow + "/topic_assistance_slow/generate",
  select_topic_assistance_case: rootUrl + "/topic_assistance/select_topic_assistance_case",
  recommend_paper: rootUrl + "/recommend/paper",

  interest_save: rootUrl + "/recommend/interest/save",

  // oauth
  oauth_authorization: rootUrl + "/oauth/authorization",

  // contactSelectByAdmin: rootUrl + '/contact/select_by_admin',
  // login: rootUrl + '/admin/login',

  // gptChatRootUrl: gptChatRootUrl,
  // gptChatUrl: gptChatRootUrl + '/cxgpt/chat',

  // gptOtherRootUrl: gptOtherRootUrl,
  // gptFindHistoryChat: gptOtherRootUrl + '/cxgpt/history',
  // gptPollingFindChat: gptOtherRootUrl + '/cxgpt/search_answer',

  // 客服二维码路径
  customer_service_qr_code: rootUrl + "/static/common/customer_service_qr_code.png",

  // // AI服务平台测试地址
  // pdf_translation: 'https://cxaitest.cxstar.cn/asp/?index=5',
  // literature_review: 'https://cxaitest.cxstar.cn/asp/?index=4',
  // AI服务平台演示环境
  pdf_translation: frontRootUrl + "/asp/?index=5",
  literature_review: frontRootUrl + "/asp/?index=4",
  oauth_ipLogin: rootUrl + "/oauth/ip_login",
  get_user_info: rootUrl + "/user_operate/get_user_info",
  get_user_login_org_info: rootUrl + "/user_operate/get_user_login_org_info",
  get_trial_status: rootUrl + "/scholarly_operate/get_trial_status",
  get_authorization_url: rootUrl + "/oauth/get_authorization_url",
  getUniqueLoginToken: childrenUrl + "/api/v1/cx/uniqueLogin",
  binaryAudioTranscribe: frontRootUrl + "/sst/transcribe/binary",
  checkTokenUrl: frontRootUrl + "/checktoken",
};

export { globalUrl, frontRootUrl };
